import React from 'react';
import Chart from 'react-apexcharts';

const ThemeChart = ({ type = null, series, options }) => {
  return <Chart options={options} series={series} type={type} width="100%" height="100%" />;
};

export default ThemeChart;
